import { connect } from "react-redux"
import { useEffect } from "react";
import {
  generateReconciliationOfValuationMethodsReport,
  setReconciliationOfValuationMethodsReport,
  updateReconciliationOfValuationMethodsReport
} from "../../../../store/modules/financials/actions";
import BVAInput from "../../../../components/BVAInput/BVAInput";
import ReconciliationValuationMethodsReport, {
  ReconciliationValuationMethodsReportGroup,
  ReconciliationValuationMethodsReportGroupItem,
  MinorityShareholderDiscount
} from "../../../../models/valuation/ReconciliationValuationMethodsReport";
import FinancialHandler from "../../../../handlers/FinancialHandler";
import CurrencyFormatter from "currency-formatter";

function ReconciliationOfValuationMethods({
  appState,
  currentReconciliationOfValuationMethodsReport,
  dispatchGenerateReconciliationOfValuationMethodsReport,
  dispatchUpdateReconciliationValuationMethodsReport,
  dispatchSetReconciliationOfValuationMethodsReport,
}) {
  // Mounted
  useEffect(() => {
    dispatchSetReconciliationOfValuationMethodsReport()
    setTimeout(() => {
      dispatchGenerateReconciliationOfValuationMethodsReport()
    }, 1000)
  }, [])

  // Methods
  const handleInputOnChange = ({ key, value, groupKey, groupItemKey }) => {
    let _value = value
    if (key === "weight") _value = value.replace(/[^0-9]/g, '')
    if (key === "value") _value = value

    const updatedReport = new ReconciliationValuationMethodsReport({
      ...currentReconciliationOfValuationMethodsReport,
      reportGroups: currentReconciliationOfValuationMethodsReport.reportGroups.map((reportGroup) => {
        if (reportGroup.groupKey !== groupKey) return reportGroup

        return new ReconciliationValuationMethodsReportGroup({
          ...reportGroup,
          groupItems: reportGroup.groupItems.map((groupItem) => {
            if (groupItem.groupItemKey !== groupItemKey) return groupItem

            return new ReconciliationValuationMethodsReportGroupItem({
              ...groupItem,
              [key]: _value
            })
          })
        })
      })
    })

    dispatchUpdateReconciliationValuationMethodsReport(updatedReport)
  }

  const handleMinorityShareholderDiscountOnChange = (key, value) => {
    const updatedReport = new ReconciliationValuationMethodsReport({
      ...currentReconciliationOfValuationMethodsReport,
      reportGroups: currentReconciliationOfValuationMethodsReport.reportGroups.map((reportGroup) => {
        return new ReconciliationValuationMethodsReportGroup({
          ...reportGroup,
          groupItems: reportGroup.groupItems.map((groupItem) => {
            return new ReconciliationValuationMethodsReportGroupItem({
              ...groupItem,
            })
          })
        })
      }),
      minorityShareholderDiscount: new MinorityShareholderDiscount({
        ...currentReconciliationOfValuationMethodsReport.minorityShareholderDiscount,
        [key]: value
      })
    })

    dispatchUpdateReconciliationValuationMethodsReport(updatedReport)
  }

  const handleOnClickGPT = async (type) => {
    handleMinorityShareholderDiscountOnChange(type, "Generating...");
    let payload = "These are the company's determination of final value data.";

    if(type === "middleNote") {
      currentReconciliationOfValuationMethodsReport?.reportGroups?.map((reportGroup) => {
        reportGroup?.groupItems?.map((groupItem) => {
          if(!groupItem?.name.includes("Pratt") && !groupItem?.name.includes("Shiltz")) payload +=
            "\n" + groupItem?.name + " is " + groupItem?.formattedValue +" and its weight is " + Number(groupItem?.weight).toFixed(2) + "%.";
        })
      });
      payload +=
        "\nThe analyst weights those methods, then uses any excess assets or liabilities to determine the Enterprise Value at 100% ownership." +
        "\nAssets / Liabilities Excess is " + currentReconciliationOfValuationMethodsReport?.formattedExcessAssetsOrLiabilities +
        ".\nThus, Determined Enterprise Value is " + currentReconciliationOfValuationMethodsReport?.formattedTotalSummary +
        "\nThe Total Liabilities will be subtracted from the Determined Enterprise Value to generate the Equity Value of the business." +
        ".\Total Liabilities is " + currentReconciliationOfValuationMethodsReport?.formattedAdjustedLiabilities +
        ".\nAs a result, Equity Value is " + currentReconciliationOfValuationMethodsReport?.formattedtotalEquitySummary;
    }
    else {
      payload +=
        "\nThe analyst can adjust the value for the exact ownership amount less than 100%. The analyst may add a Discount for Lack of Control—an amount or percentage deducted from the pro rata share value of 100% of an equity interest in a business to reflect the absence of some or all of the powers of control and a Discount for Lack of Marketability—an amount or percentage deducted from the value of an ownership interest to reflect the relative absence of marketability. From these discounts, the final equity value is derived." +
        "\nThe equity value of the business is " + currentReconciliationOfValuationMethodsReport?.formattedtotalEquitySummary +
        " and ownership interest percentage is " +
        Number(currentReconciliationOfValuationMethodsReport?.minorityShareholderDiscount?.ownershipInterestPercentage).toFixed(2) +
        "%, which results in " +
        currentReconciliationOfValuationMethodsReport?.ownershipInterestAmountFormatted +
        ".\nDiscount for Lack of Control is " +
        Number(currentReconciliationOfValuationMethodsReport?.minorityShareholderDiscount?.discountForControlPercentage).toFixed(2) +
        "% of this result and so the value after that is " +
        currentReconciliationOfValuationMethodsReport?.discountForControlAmountFormatted +
        ".\nDiscount for Lack of Marketability is " +
        Number(currentReconciliationOfValuationMethodsReport?.minorityShareholderDiscount?.discountForLackOfMarketability).toFixed(2) +
        "% of this result.\nSo the Determined Enterprise Value is " +
        currentReconciliationOfValuationMethodsReport?.minorityShareholderDiscountDeterminedFinalValueFormatted;
    }
    payload += ".\nPlease analyze the company's situation."

    const note = await FinancialHandler.fetchGPTSimpleNoteGeneration(payload);
    handleMinorityShareholderDiscountOnChange(type, note);
  }

  return (
    <>
      <h2 className="sectionHead">Reconciliation of Valuation Methods and Determination of Final Value</h2>
      <section className="py-10 flex justify-center items-center flex-col">
        <div className="mt-10">
          <div className="flex items-center w-full">
            <div className="w-96"></div>
            <div className="w-40 font-semibold">
              <label className="whitespace-nowrap">Value</label>
            </div>
            <div className="w-40 font-semibold">
              <label className="whitespace-nowrap">Weight</label>
            </div>
            <div className="w-60 font-semibold">
              <label className="whitespace-nowrap">Summary</label>
            </div>
          </div>

          <div>
            {currentReconciliationOfValuationMethodsReport?.reportGroups?.map((reportGroup, reportGroupIndex) => (
              <div className="mt-8" key={reportGroupIndex}>
                <div className="w-96 flex items-center pr-2">
                  <label className="whitespace-nowrap text-center font-semibold">
                    {reportGroup?.groupName}
                  </label>
                </div>
                <div className="mt-2">
                  {reportGroup?.groupItems?.map((groupItem, groupItemIndex) => 
                    (groupItem?.name.includes("Pratt") || groupItem?.name.includes("Shiltz")) ?
                    (<div />)
                    :
                    (<div className="flex mb-2 items-center" key={groupItemIndex}>
                      <div className="w-96 flex items-center pr-2">
                        <label className="whitespace-nowrap text-center">
                          {groupItem?.name}
                        </label>
                      </div>
                      <div className="w-40 flex items-center pr-2">
                        {groupItem?.allowInput ? (
                          <BVAInput
                            value={groupItem.value}
                            startAdornment
                            startAdornmentLabel="$ "
                            onChange={(value) => handleInputOnChange({
                              value,
                              key: "value",
                              groupKey: reportGroup.groupKey,
                              groupItemKey: groupItem.groupItemKey
                            })} />
                        ) : (
                          <label className="whitespace-nowrap">
                            {groupItem?.formattedValue}
                          </label>
                        )}
                      </div>
                      <div className="w-40 flex items-center pr-10">
                        <BVAInput
                          value={groupItem?.weight}
                          endAdornment
                          endAdornmentLabel="%"
                          onChange={(value) => handleInputOnChange({
                            value,
                            key: "weight",
                            groupKey: reportGroup.groupKey,
                            groupItemKey: groupItem.groupItemKey
                          })} />
                      </div>
                      <div className="w-40 flex items-center pr-2">
                        <label className="whitespace-nowrap">
                          {groupItem?.formattedSummary}
                        </label>
                      </div>
                    </div>)
                  )}
                </div>
              </div>
            ))}

            <div className="flex items-center mt-8 bg-neutral-100 p-5 rounded-lg">
              <div className="w-96 flex justify-center flex-col pr-2">
                <label className="whitespace-nowrap font-semibold">
                  Excess Assets / Liabilities
                </label>
              </div>
              <div className="w-40 flex items-center pr-2 -ml-5">
                <label className="whitespace-nowrap"></label>
              </div>
              <div className="w-40 flex items-center pr-2">
                <label className="whitespace-nowrap"></label>
              </div>
              <div className="w-40 flex items-center pr-2">
                <label className="whitespace-nowrap">
                  {currentReconciliationOfValuationMethodsReport?.formattedExcessAssetsOrLiabilities}
                </label>
              </div>
            </div>
            <div className="flex items-center bg-neutral-100 p-5 rounded-lg mt-4">
              <div className="w-96 flex justify-center flex-col pr-2">
                <label className="whitespace-nowrap font-semibold">
                  Determined Enterprise Value
                </label>
                <div>
                  <label className="">(of 100% Ownership Interest)</label>
                </div>
              </div>
              <div className="w-40 flex items-center pr-2 -ml-5">
                <label className="whitespace-nowrap"></label>
              </div>
              <div className="w-40 flex items-center pl-5 pr-2">
                <label className="whitespace-nowrap">
                  {currentReconciliationOfValuationMethodsReport?.formattedTotalWeight} %
                </label>
              </div>
              <div className="w-40 flex items-center pr-2">
                <label className="whitespace-nowrap">
                  {currentReconciliationOfValuationMethodsReport?.formattedTotalSummary}
                </label>
              </div>
            </div>
            <div className="flex items-center bg-neutral-100 p-5 rounded-lg mt-4">
              <div className="w-96 flex justify-center flex-col pr-2">
                <label className="whitespace-nowrap font-semibold">
                  Total Liabilities
                </label>
              </div>
              <div className="w-40 flex items-center pr-2 -ml-5">
                <label className="whitespace-nowrap"></label>
              </div>
              <div className="w-40 flex items-center pl-5 pr-2" />
              <div className="w-40 flex items-center pr-2">
                <label className="whitespace-nowrap">
                  {currentReconciliationOfValuationMethodsReport?.formattedAdjustedLiabilities}
                </label>
              </div>
            </div>
            <div className="flex items-center bg-neutral-100 p-5 rounded-lg mt-4">
              <div className="w-96 flex justify-center flex-col pr-2">
                <label className="whitespace-nowrap font-semibold">
                  Equity Value
                </label>
              </div>
              <div className="w-40 flex items-center pr-2 -ml-5">
                <label className="whitespace-nowrap"></label>
              </div>
              <div className="w-40 flex items-center pl-5 pr-2" />
              <div className="w-40 flex items-center pr-2">
                <label className="whitespace-nowrap">
                  {currentReconciliationOfValuationMethodsReport?.formattedtotalEquitySummary}
                </label>
              </div>
            </div>
            <div className="data-bottom mt-10">
              <h5 className="noteHead font-semibold ml-4">
                Analyst Note&nbsp;&nbsp;&nbsp;
                <button onClick={() => handleOnClickGPT("middleNote")}>🤖</button>
              </h5>
              <textarea
                className="analystNote"
                rows={4}
                value={currentReconciliationOfValuationMethodsReport?.minorityShareholderDiscount?.middleNote}
                onChange={(e) => handleMinorityShareholderDiscountOnChange("middleNote", e.target.value)}
              />
            </div>

          </div>
        </div>
        <div className="mt-10">
          <div className="dashboard-content">
            <div className="data-title-container">
              <div></div>

              <div className="data-title">
                <h6>{appState.companyData.name}</h6>
                <p>Minority Shareholder Discount</p>
              </div>
            </div>
          </div>

          <div className="mt-4 border p-5 rounded">
            <div className="flex mb-2 items-center">
              <div className="w-96 flex items-center pr-2">
                <label className="whitespace-nowrap text-center">
                  Ownership Interest
                </label>
              </div>
              <div className="w-40 flex items-center pr-2" />
              <div className="w-40 flex items-center pr-10 -ml-5">
                <BVAInput
                  endAdornment
                  endAdornmentLabel="%"
                  value={currentReconciliationOfValuationMethodsReport?.minorityShareholderDiscount?.ownershipInterestPercentage}
                  onChange={(value) => handleMinorityShareholderDiscountOnChange("ownershipInterestPercentage", value)} />
              </div>
              <div className="w-40 flex items-center pr-2">
                <label className="whitespace-nowrap">
                  {currentReconciliationOfValuationMethodsReport?.ownershipInterestAmountFormatted}
                </label>
              </div>
            </div>
            <div className="flex mb-2 items-center">
              <div className="w-96 flex items-center pr-2">
                <label className="whitespace-nowrap text-center">
                  After Discount for Lack of Control
                </label>
              </div>
              <div className="w-40 flex items-center pr-2" />
              <div className="w-40 flex items-center pr-10 -ml-5">
                <BVAInput
                  endAdornment
                  endAdornmentLabel="%"
                  value={currentReconciliationOfValuationMethodsReport?.minorityShareholderDiscount?.discountForControlPercentage}
                  onChange={(value) => handleMinorityShareholderDiscountOnChange("discountForControlPercentage", value)} />
              </div>
              <div className="w-40 flex items-center pr-2">
                <label className="whitespace-nowrap">
                  {currentReconciliationOfValuationMethodsReport?.discountForControlAmountFormatted}
                </label>
              </div>
            </div>
            <div className="flex mb-2 items-center">
              <div className="w-96 flex items-center pr-2">
                <label className="whitespace-nowrap text-center">
                  After Discount for Lack of Marketability
                </label>
              </div>
              <div className="w-40 flex items-center pr-2" />
              <div className="w-40 flex items-center pr-10 -ml-5">
                <BVAInput
                  endAdornment
                  endAdornmentLabel="%"
                  value={currentReconciliationOfValuationMethodsReport?.minorityShareholderDiscount?.discountForLackOfMarketability}
                  onChange={(value) => handleMinorityShareholderDiscountOnChange("discountForLackOfMarketability", value)} />
              </div>
              <div className="w-40 flex items-center pr-2">
                <label className="whitespace-nowrap">
                  {currentReconciliationOfValuationMethodsReport?.discountForLackOfMarketabilityAmountFormatted}
                </label>
              </div>
            </div>
            <div className="flex items-center bg-neutral-100 p-5 rounded-lg mt-4">
              <div className="w-96 flex justify-center flex-col pr-2">
                <label className="whitespace-nowrap font-semibold">
                  Determined Equity Value
                </label>
              </div>
              <div className="w-40 flex items-center pr-2 -ml-5" />
              <div className="w-40 flex items-center pr-2 -ml-5" />
              <div className="w-40 flex items-center pr-2">
                <label className="whitespace-nowrap">
                  {currentReconciliationOfValuationMethodsReport?.minorityShareholderDiscountDeterminedFinalValueFormatted}
                </label>
              </div>
            </div>
          </div>
          <div className="data-bottom mt-10">
            <h5 className="noteHead font-semibold ml-4">
              Analyst Note&nbsp;&nbsp;&nbsp;
              <button onClick={() => handleOnClickGPT("finalNote")}>🤖</button>
            </h5>
            <textarea
              className="analystNote"
              rows={4}
              value={currentReconciliationOfValuationMethodsReport?.minorityShareholderDiscount?.finalNote}
              onChange={(e) => handleMinorityShareholderDiscountOnChange("finalNote", e.target.value)}
            />
          </div>
        </div>
      </section>
    </>
  )
}


const mapStateToProps = (state) => ({
  currentReconciliationOfValuationMethodsReport: state.financials.currentReconciliationOfValuationMethodsReport,
  appState: state.appState
})

const mapDispatchToProps = (dispatch) => ({
  dispatchGenerateReconciliationOfValuationMethodsReport() {
    dispatch(generateReconciliationOfValuationMethodsReport())
  },

  dispatchSetReconciliationOfValuationMethodsReport() {
    dispatch(setReconciliationOfValuationMethodsReport())
  },

  dispatchUpdateReconciliationValuationMethodsReport(updatedReport) {
    dispatch(updateReconciliationOfValuationMethodsReport(updatedReport))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(ReconciliationOfValuationMethods)
